import axios from 'axios';
import { GraphQLError, AuthenticationError, ValidationError } from './errors';

const defaultHeaders = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
};

export default class GraphQL {
    constructor({ uri = undefined, headers = {} } = {}) {
        if (typeof uri === 'undefined') {
            uri = process.env.VUE_APP_API_URI;
        }
        this.uri = uri;
        this.headers = Object.assign({}, defaultHeaders, headers);
    }

    async query({ query, variables }) {
        let response = null;

        const payload = { query };
        if (typeof variables !== 'undefined') {
            payload.variables = variables;
        }

        response = await axios({
            url: this.uri,
            headers: this.headers,
            method: 'post',
            data: payload
        });

        const { data, errors: graphQLErrors } = response.data;
        if (typeof graphQLErrors !== 'undefined' && graphQLErrors.length > 0) {
            const authenticationError = graphQLErrors.find(function(error) {
                return error.extensions.category === 'authentication';
            });

            const validationError = graphQLErrors.find(function(error) {
                return error.extensions.category === 'validation';
            });

            if (typeof authenticationError !== 'undefined') {
                throw new AuthenticationError(authenticationError.message);
            } else if (typeof validationError !== 'undefined') {
                const { validation } = validationError.extensions;
                const firstValidator = Object.keys(validation)[0];
                throw new ValidationError(validation[firstValidator][0]);
            } else {
                throw new GraphQLError(graphQLErrors[0].message);
            }
        }

        return { data };
    }
}
